export default "__VITE_ASSET__xpDrrNKQ__"